import { PayloadsType } from '../utils/types';

export const Name = 'sms-invite-copy';

export enum PayloadType {
  Control = 'NEW_OFFER',
  TestA = 'NEW_OFFER_VARIANTS.A',
  TestB = 'NEW_OFFER_VARIANTS.B',
  TestC = 'NEW_OFFER_VARIANTS.C',
  TestD = 'NEW_OFFER_VARIANTS.D',
  TestE = 'NEW_OFFER_VARIANTS.E',
  TestF = 'NEW_OFFER_VARIANTS.F',
  TestG = 'NEW_OFFER_VARIANTS.G',
  TestH = 'NEW_OFFER_VARIANTS.H',
}

export enum VariantType {
  Control = 'control',
  TestA = 'test_a',
  TestB = 'test_b',
  TestC = 'test_c',
  TestD = 'test_d',
  TestE = 'test_e',
  TestF = 'test_f',
  TestG = 'test_g',
  TestH = 'test_h',
}

export const Payloads: PayloadsType<PayloadType, VariantType> = {
  [VariantType.Control]: PayloadType.Control,
  [VariantType.TestA]: PayloadType.TestA,
  [VariantType.TestB]: PayloadType.TestB,
  [VariantType.TestC]: PayloadType.TestC,
  [VariantType.TestD]: PayloadType.TestD,
  [VariantType.TestE]: PayloadType.TestE,
  [VariantType.TestF]: PayloadType.TestF,
  [VariantType.TestG]: PayloadType.TestG,
  [VariantType.TestH]: PayloadType.TestH,
};

export const PAYLOADS_WITH_SALARY_INFO = [
  PayloadType.TestB,
  PayloadType.TestC,
  PayloadType.TestD,
  PayloadType.TestE,
  PayloadType.TestF,
  PayloadType.TestG,
  PayloadType.TestH,
];
